import React from "react";
import { observer } from "mobx-react";
import { PaymentReceiptTypeCreateStore } from "../../store";
import { PaymentReceiptTypeCreateForm } from "./PaymentReceiptTypeCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type PaymentReceiptTypeCreateProps = {
  paymentReceiptTypeCreateStore: PaymentReceiptTypeCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PaymentReceiptTypeCreate: React.FC<PaymentReceiptTypeCreateProps> =
  observer(
    ({ paymentReceiptTypeCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={paymentReceiptTypeCreateStore.isSaving} />
          <PaymentReceiptTypeCreateForm
            paymentReceiptTypeCreateStore={paymentReceiptTypeCreateStore}
            name_esError={paymentReceiptTypeCreateStore.errors.name_es?.message}
            onName_esChange={(value: string) => {
              paymentReceiptTypeCreateStore.setName_esValue(value);
            }}
            name_es={paymentReceiptTypeCreateStore.entityValues.name_es}
            name_enError={paymentReceiptTypeCreateStore.errors.name_en?.message}
            onName_enChange={(value: string) => {
              paymentReceiptTypeCreateStore.setName_enValue(value);
            }}
            name_en={paymentReceiptTypeCreateStore.entityValues.name_en}
            name_ptError={paymentReceiptTypeCreateStore.errors.name_pt?.message}
            onName_ptChange={(value: string) => {
              paymentReceiptTypeCreateStore.setName_ptValue(value);
            }}
            name_pt={paymentReceiptTypeCreateStore.entityValues.name_pt}
            priceError={paymentReceiptTypeCreateStore.errors.price?.message}
            onPriceChange={(value: number) => {
              paymentReceiptTypeCreateStore.setPriceValue(value);
            }}
            price={paymentReceiptTypeCreateStore.entityValues.price}
            currencyError={
              paymentReceiptTypeCreateStore.errors.currency?.message
            }
            onCurrencyChange={(value) => {
              paymentReceiptTypeCreateStore.setCurrencyValue(value);
            }}
            currencySelectedValue={
              paymentReceiptTypeCreateStore.entityValues.showCurrency
            }
            onCurrencySelected={(value) => {
              paymentReceiptTypeCreateStore.setSelectedCurrency(value);
            }}
            currencyOptions={paymentReceiptTypeCreateStore.getCurrencyOptions()}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={paymentReceiptTypeCreateStore.isProcessing}
            onSave={() =>
              paymentReceiptTypeCreateStore.saveNewPaymentReceiptType()
            }
            onCancel={() =>
              paymentReceiptTypeCreateStore.cancelNewPaymentReceiptType()
            }
          />
          <ErrorDialog
            open={paymentReceiptTypeCreateStore.errorDialogOpened}
            title={paymentReceiptTypeCreateStore.errorTitle}
            description={paymentReceiptTypeCreateStore.errorDescription}
            onClose={() => paymentReceiptTypeCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
